// Generated by `pnpm --filter @hyranai/regta-blocks blocks:lock` from blocks.lock.json — do not edit.
// Blocks at minor 0 are omitted.
export const BLOCK_MINORS = {
    'avstaende_besittningsskydd_bostad.overenskommelsens-innehall@v1': 1,
    'avstaende_besittningsskydd_lokal.overenskommelsens-innehall@v1': 1,
    'bostadshyra.forhandlingsklausul@v1': 1,
    'bostadshyra.garage@v1': 1,
    'bostadshyra.sarskilda-bestammelser@v1': 1,
    'bostadshyra.tillagg@v1': 1,
    'bostadshyra.tillbehor@v1': 1,
    'framstallan.sammantrade@v1': 1,
    'garage.betalning@v1': 1,
    'garage.personuppgifter@v1': 1,
    'godkannande_18d.bilagor@v1': 1,
    'godkannande_18d.godkannande@v1': 1,
    'lokalhyra.avfallshantering@v1': 1,
    'lokalhyra.bevakning@v1': 1,
    'lokalhyra.brandskydd@v1': 1,
    'lokalhyra.hyra@v1': 1,
    'lokalhyra.ombyggnad@v1': 1,
    'lokalhyra.skatter-avgifter@v1': 1,
    'lokalhyra.skyltning@v1': 1,
    'lokalhyra.underhall@v1': 1,
    'studentbostad.forhandlingsklausul@v1': 1,
    'studentbostad.storlek@v1': 1,
    'studentbostad.tillagg@v1': 1,
    'studentbostad.tillbehor@v1': 1,
    'tillaggsavtal_hyresgastanpassning.hyresgastanpassning@v1': 1,
    'tillaggsavtal_hyresgastanpassning.tvist@v1': 1,
};
//# sourceMappingURL=minors.js.map